// 存放共用數據的key
export const STORAGE_KEY = {
  HOME_SHOW_ANIMATION: 'homeShowAnimation', // 首頁是否展示過動畫
  CREATE_MEMBER_REQUEST: 'createMemberRequest', // 註冊請求
  LOGIN_STATUS: 'loginStatus', // 登入狀態用來判斷後續是否需要做預約中註冊
  ID_LOGIN_REQUEST: 'idLoginRequest', // 漸進式登入
  RESERVE_STEP: 'reserveStep', // 當前預約步驟
  RESERVE_TYPE: 'reserveType', // 預約類型
  USER_PLAN_REQUEST: 'userPlanRequest', // 預約請求
  USER_PLAN_RESPONSE: 'userPlanResponse', // 個人方案結果
  BUSINESS_PLAN_REQUEST: 'businessPlanRequest', // 企業方案請求
  EXAM_ITEM_LIST: 'examItemList', // 選擇之方案底下的所有檢項
  ADD_EXAM_ITEM_LIST: 'addExamItemList',
  MY_RESERVATION: 'myReservation', // 我的預約資訊
  BOOKING_INFO: 'bookingInfo', // 預約資訊
  BUSINESS_LOGIN_INFO: 'businessLoginInfo', // 企業登入相關信息
  SKIP_PASSWORD_REMINDER: 'skipPasswordReminder', // 用於記錄是否跳過密碼提醒
  TEMP_PERSONAL_DISEASE_DETAILS: 'tempPersonalDiseaseDetails', // 暫存個人病史詳細症狀
  TEMP_PERSONAL_DISEASE_CHECK: 'tempPersonalDiseaseCheck', // 暫存個人病史勾選項目
  TEMP_PERSONAL_NONE_OF_FOLLOWING: 'tempPersonalNoneOfFollowing', // 暫存個人病史"以下皆無"是否勾選
  TEMP_FAMILY_DISEASE_CHECK: 'tempFamilyDiseaseCheck', // 暫存家族病史勾選項目
  TEMP_FAMILY_NONE_OF_FOLLOWING: 'tempFamilyNoneOfFollowing', // 暫存家族病史"以下皆無"是否勾選
  TEMP_SUBJECTIVE_SYMPTOM_DISEASE_CHECK: 'tempSubjectiveSymptomDiseaseCheck', // 暫存自覺症狀勾選項目
  TEMP_SUBJECTIVE_SYMPTOM_NONE_OF_FOLLOWING: 'tempSubjectiveSymptomNoneOfFollowing', // 暫存自覺症狀"以下皆無"是否勾選
  PHONE_VERIFIED_STATUS: 'phoneVerifiedStatus', // 手機驗證狀態
  REDIRECT_TO_COMPANY_LOGIN: 'redirectToCompanyLogin', // 登入後是否需要導向企業登入頁面
} as const;
